import {useEvent} from 'Event/EventProvider'
import {useObieJourneys} from 'lib/event-api/integrations/obie/journeys/list'
import Select from 'lib/ui/Select'
import Option from 'lib/ui/Select/Option'
import {useOrganization} from 'organization/OrganizationProvider'
import React from 'react'

export interface JourneySelectProps {
  obieHubId: string
  value: string
  onChange: (obieJourneyId: string) => void
  disabled?: boolean
}

export default function JourneySelect(props: JourneySelectProps) {
  const {obieHubId, value, onChange, disabled} = props
  const {event} = useEvent()
  const {client} = useOrganization()
  const {data: journeys = [], isLoading, error} = useObieJourneys({
    client,
    event,
    obieHubId,
  })

  if (isLoading) {
    return (
      <Select
        label="Journey"
        aria-label="journey"
        value=""
        onChange={() => {}}
        displayEmpty
        disabled
        fullWidth
      >
        <Option value="">Loading…</Option>
      </Select>
    )
  }

  if (error) {
    return (
      <Select
        label="Journey"
        aria-label="journey"
        helperText={error.message}
        error
        value=""
        onChange={() => {}}
        disabled
        fullWidth
      />
    )
  }

  if (journeys.length === 0) {
    return (
      <Select
        label="Journey"
        aria-label="journey"
        value=""
        onChange={() => {}}
        displayEmpty
        disabled
        fullWidth
      >
        <Option value="">
          This AI Hub has no published journeys. Publish one in Obie, then
          reload this page.
        </Option>
      </Select>
    )
  }

  const isSavedJourneyMissing =
    Boolean(value) && !journeys.some((journey) => journey.id === value)

  return (
    <Select
      label="Journey"
      aria-label="journey"
      value={value}
      onChange={(event) => onChange(String(event.target.value))}
      disabled={disabled}
      fullWidth
    >
      {isSavedJourneyMissing && (
        <Option value={value} disabled>
          Not in this AI Hub
        </Option>
      )}
      {journeys.map((journey) => (
        <Option key={journey.id} value={journey.id}>
          {journey.name}
        </Option>
      ))}
    </Select>
  )
}
